import { render } from "./StatisticalEvalTeamPage.vue?vue&type=template&id=1b108ec1&scoped=true&ts=true"
import script from "./StatisticalEvalTeamPage.vue?vue&type=script&lang=ts"
export * from "./StatisticalEvalTeamPage.vue?vue&type=script&lang=ts"

import "./StatisticalEvalTeamPage.vue?vue&type=style&index=0&id=1b108ec1&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/DanhGia_FE/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b108ec1"]])

export default __exports__